/**
 * Cost Centers Catalog Mapper
 */

import type { LC_CostCenterItem, CostCenter } from './costCenters.types.ts';

/**
 * Map LC_CostCenterItem to CostCenter
 */
export function mapCostCenterOutToModel(item: LC_CostCenterItem): CostCenter {
  return {
    id: item.costCenterId,
    name: item.costCenter,
  };
}
